export default function flattenArray<T>(array: T[][]): T[] {
  const emptyArray: T[] = [];
  return emptyArray.concat(...array);
}
